import { FormItemProps, Col, Form } from "antd";

import { StepsForm } from "@components/Steps/Form";

export type FormFieldProps = FormItemProps & {
  FormItemComponent?: typeof Form.Item;
};

export const FormField = (props: FormFieldProps) => {
  const { FormItemComponent = Form.Item, wrapperCol, ...formItemProps } = props;

  return (
    <Col {...wrapperCol}>
      <FormItemComponent {...formItemProps} />
    </Col>
  );
};

export const StepsFormField = (props: FormFieldProps) => (
  <FormField FormItemComponent={StepsForm.Item} {...props} />
);
